export enum NotificationRecipient {
  PASSENGER = 'PASSENGER',
  DRIVER = 'DRIVER',
  SUPERADMIN = 'SUPERADMIN',
  ADMIN = 'ADMIN',
  OPERATOR = 'OPERATOR',
  DRIVER_MANAGER = 'DRIVER_MANAGER',
}
